import { generateRGBPalette } from '../helpers'
import {
  BAR_CHART_COLOR_LIGHT,
  BAR_CHART_SELECTED_COLOR_LIGHT,
  BAR_CHART_SELECTED_SHADOW_COLOR_LIGHT,
  PIE_CHART_PALETTE_LIGHT,
} from '../const'

export default {
  color: generateRGBPalette(
    PIE_CHART_PALETTE_LIGHT[0],
    PIE_CHART_PALETTE_LIGHT[1],
    8,
  ),
  textStyle: {},
  title: {
    textStyle: {
      color: '#c8c8c8',
    },
    subtextStyle: {
      color: '#c8c8c8',
    },
  },
  label: {
    color: '#585F6D',
    rich: {
      value: {
        fontSize: 10,
        color: '#c8c8c8',
      },
    },
  },
  legend: {
    textStyle: {
      color: '#585F6D',
    },
  },
  bar: {
    color: BAR_CHART_COLOR_LIGHT,
    select: {
      itemStyle: {
        color: BAR_CHART_SELECTED_COLOR_LIGHT,
        borderWidth: 0,
        shadowBlur: 10,
        shadowColor: BAR_CHART_SELECTED_SHADOW_COLOR_LIGHT,
        shadowOffsetY: 5,
      },
    },
  },
  pie: {
    itemStyle: {
      borderWidth: 1,
      borderColor: '#fff',
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#474C5A',
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#DEE1E7',
      },
    },
    axisLabel: {
      show: true,
      color: '#474C5A',
    },
  },
  valueAxis: {
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: true,
      color: '#474C5A',
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#DEE1E7', '#EDEDED'],
      },
    },
  },
}
